import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = '',
  ...props
}: ButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`relative group overflow-hidden bg-tactical-cyan text-tactical-dark font-oswald font-bold text-xl px-8 py-4 rounded-sm flex items-center justify-center gap-2 transition-all hover:box-glow ${className}`} {...props} data-id="element-231">
      <span className="relative z-10 flex items-center gap-2" data-id="element-232">
        {children}
        <ChevronRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-233" />
      </span>
      {/* Shine effect */}
      <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-12" data-id="element-234"></div>
    </motion.button>;
}